import Vue from "vue";
import VueRouter from "vue-router";
//import store from "../store/index"

Vue.use(VueRouter);

const routes = [
  //Home route
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home/Home.vue")
  },

  //Change password
  {
    path: "/ChangePassword",
    name: "ChangePassword",
    component: () =>
      import("../views/Security/ChangePassword/ChangePassword.vue")
  },

  //Send password reset email
  {
    path: "/ResetEmail",
    name: "ResetEmail",
    component: () => import("../views/Security/ForgotPassword/email.vue")
  },

  //Reset password
  {
    path: "/ResetPassword",
    name: "ResetPassword",
    component: () =>
      import("../views/Security/ForgotPassword/ResetPassword.vue")
  },

  //User/Customer Routes
  {
    path: "/dashboard",
    name: "Brain",
    component: () => import("../views/Client/Brain/Brain.vue"),
    meta: { authRequired: true },
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () => import("../views/Client/Dashboard/Dashboard.vue")
      },
      {
        path: "/Statement",
        name: "Statement",
        component: () => import("../views/Client/Statement/Statement.vue")
      },
      {
        path: "/Beneficiary",
        name: "Beneficiary",
        component: () => import("../views/Client/Beneficiary/Beneficiary.vue")
      },
      {
        path: "/Account",
        name: "Account",
        component: () => import("../views/Client/Account/Account.vue")
      },
      {
        path: "/Transfer",
        name: "Transfer",
        component: () => import("../views/Client/Transfer/Options.vue")
      },
      {
        path: "/TransferOwn",
        name: "TransferOwn",
        component: () => import("../views/Client/Transfer/Own.vue")
      },
      {
        path: "/TransferSame",
        name: "TransferSame",
        component: () => import("../views/Client/Transfer/Same.vue")
      },
      {
        path: "/TransferOther",
        name: "TransferOther",
        component: () => import("../views/Client/Transfer/Other.vue")
      },
      {
        path: "/Fund",
        name: "Fund",
        component: () => import("../views/Client/Transfer/Fund.vue")
      },
      {
        path: "/Utility",
        name: "Utility",
        component: () => import("../views/Client/Utility/Options.vue")
      },
      {
        path: "/Utility-Mobile",
        name: "Utility-Mobile",
        component: () => import("../views/Client/Utility/Mobile.vue")
      },
      {
        path: "/Utility-Ecommerce",
        name: "Utility-Ecommerce",
        component: () => import("../views/Client/Utility/Ecommerce.vue")
      },
      {
        path: "/Utility-Cable",
        name: "Utility-Cable",
        component: () => import("../views/Client/Utility/Cable.vue")
      },
      {
        path: "/Utility-Internet",
        name: "Utility-Internet",
        component: () => import("../views/Client/Utility/Internet.vue")
      },
      {
        path: "/Loan-Precheck",
        name: "Loan-Precheck",
        component: () => import("../views/Client/Loan/Precheck.vue")
      },
      {
        path: "/Loan-personal",
        name: "Loan-personal",
        component: () => import("../views/Client/Loan/personal.vue")
      },
      {
        path: "/Loan-Apply",
        name: "Loan-Apply",
        component: () => import("../views/Client/Loan/Apply.vue")
      },
      {
        path: "/Loan-Guarantor",
        name: "Loan-Guarantor",
        component: () => import("../views/Client/Loan/Guarantor.vue")
      },
      {
        path: "/Loan-Collateral",
        name: "Loan-Collateral",
        component: () => import("../views/Client/Loan/Collateral.vue")
      },
      {
        path: "/Loan-Collateral",
        name: "Loan-Collateral",
        component: () => import("../views/Client/Loan/Collateral.vue")
      },
      {
        path: "/Loan",
        name: "Loan",
        component: () => import("../views/Client/Loan/Loan.vue")
      },
      {
        path: "/Investment-Precheck",
        name: "Investment-Precheck",
        component: () => import("../views/Client/Investment/Precheck.vue")
      },
      {
        path: "/Investment-Apply",
        name: "Investment-Apply",
        component: () => import("../views/Client/Investment/Apply.vue")
      },

      {
        path: "/Investment",
        name: "Investment",
        component: () => import("../views/Client/Investment/Investment.vue")
      }
    ]
  },
  //Admin Routes
  {
    path: "/admin/login",
    name: "admin/login",
    component: () => import("../views/Admin/Login/Login.vue")
  },
  {
    path: "/Admin",
    name: "Admin",
    component: () => import("../views/Admin/Brain/Brain.vue"),
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () => import("../views/Admin/Dashboard/Dashboard.vue")
      },
      {
        path: "/Admin/User",
        name: "User",
        component: () => import("../views/Admin/User/User.vue")
      },
      {
        path: "/Admin/Gl",
        name: "Admin/Gl",
        component: () => import("../views/Admin/Gl/Gl.vue")
      },
      {
        path: "/Admin/Products",
        name: "Admin/Products",
        component: () => import("../views/Admin/Products/Products.vue")
      },
      // {
      //   path: "/Admin/Approvals",
      //   name: "Approvals",
      //   component: () => import("../views/Admin/Approvals/Approvals.vue")
      // },
      // {
      //   path: "/Admin/Approvals/Details",
      //   name: "Details",
      //   component: () => import("../views/Admin/Approvals/Details.vue")
      // },
      {
        path: "/Admin/Reports/BalanceSheet",
        name: "Reports",
        component: () => import("../views/Admin/Reports/BalanceSheet.vue")
      },
      {
        path: "/Admin/Reports/Statement",
        name: "Reports",
        component: () => import("../views/Admin/Reports/IncomeStatement.vue")
      },
      {
        path: "/Admin/Reports/Ledger",
        name: "Reports",
        component: () => import("../views/Admin/Reports/Ledger.vue")
      },
      {
        path: "/Admin/Reports/TrialBalance",
        name: "Reports",
        component: () => import("../views/Admin/Reports/TrialBalance.vue")
      },
      {
        path: "/Admin/CREDIT",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/CreditReport.vue")
      },
      {
        path: "/Admin/CREDIT/CreditReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/CreditReport.vue")
      },
      {
        path: "/Admin/CREDIT/DailyCreditDetails",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/DailyCreditDetails.vue")
      },
      {
        path: "/Admin/CREDIT/LoanListing",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/LoanListing.vue")
      },
      {
      path: "/Admin/CREDIT/LoanDetails",
      name: "CREDIT",
      component: () => import("../views/Admin/CREDIT/Loan/LoanDetails.vue")
    },
      {
        path: "/Admin/CREDIT/ProductListing",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/ProductListing.vue")
      },
      {
        path: "/Admin/CREDIT/MaturityReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/MaturityReport.vue")
      },
      {
        path: "/Admin/CREDIT/ParReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/ParReport.vue")
      },
      {
        path: "/Admin/CREDIT/DisburseReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/DisburseReport.vue")
      },
      {
        path: "/Admin/CREDIT/RepaymentReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/RepaymentReport.vue")
      },
      {
        path: "/Admin/CREDIT/CollectionReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Loan/CollectionReport.vue")
      },
      {
        path: "/Admin/CREDIT/investmentReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Investment/InvestmentReport.vue")
      },
      {
        path: "/Admin/CREDIT/investListingReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Investment/InvestListing.vue")
      },
      {
        path: "/Admin/CREDIT/DailyInvestDetails",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Investment/DailyInvestDetails.vue")
      },
      {
        path: "/Admin/CREDIT/maturitylistingReport",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Investment/InvestmentMaturity.vue")
      },
      {
        path: "/Admin/CREDIT/InvestMatDetails",
        name: "CREDIT",
        component: () => import("../views/Admin/CREDIT/Investment/InvestMatDetails.vue")
      }
    ]
  },

  //Cso Routes
  {
    path: "/Cso",
    name: "Cso",
    component: () => import("../views/Cso/Brain/Brain.vue"),
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () => import("../views/Cso/Dashboard/Dashboard.vue")
      },
      {
        path: "/Cso/User",
        name: "User",
        component: () => import("../views/Cso/User/User.vue")
      },
      {
        path: "/Cso/customer",
        name: "User",
        component: () => import("../views/Cso/User/Customer.vue")
      },
      {
        path: "/Cso/loan",
        name: "User",
        component: () => import("../views/Cso/Loan/bookloan.vue")
      },
      {
        path: "/Cso/Loan/customerinfo",
        name: "User",
        component: () => import("../views/Cso/Loan/customerinfo.vue")
      },
      {
        path: "/Cso/Loan/Applyloan",
        name: "User",
        component: () => import("../views/Cso/Loan/Applyloan.vue")
      }
    ]
  },

  //Supervisor Routes
  {
    path: "/Super",
    name: "Super",
    component: () => import("../views/Supervisor/Brain/Brain.vue"),
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () => import("../views/Supervisor/Dashboard/Dashboard.vue")
      },
      {
        path: "/Super/Approvals",
        name: "Approvals",
        component: () => import("../views/Supervisor/Approvals/Approvals.vue")
      },
      {
        path: "/Super/Approvals/Details",
        name: "Details",
        component: () => import("../views/Supervisor/Approvals/Details.vue")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// router.beforeEach((to, from, next) => {
//   //loops through each route record and checks routes that contains the 'meta' tag
//   if (to.matched.some(record => record.meta.authRequired)) {
//     // checks if user is signed in , if not, redirect to signin page.
//     if (!store.state.User.IS_AUTHENTICATED) {
//       next({
//         path: "/login",
//         query: { redirect: to.fullPath }
//       });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// })

export default router;
